import { newGuid } from "@/assets/utils/guid";
import { MinSpendPolicy, OpeningHoursPolicy, TableBookingPolicy, OpeningHoursPolicyLimit, MinSpendPolicyLimit, TableBookingPolicyLimit, BookingHoursPolicy, BookingHoursPolicyLimit } from ".";

export class PolicyConfiguration {
  constructor(identifier, policyType, policyLevel) {
    this.policyConfigurationId = { id: newGuid() };
    this.identifier = identifier;
    this.policyType = policyType;
    this.policyLevel = policyLevel;
    this.limits = [];
  }

  static fromJSON(json) {
    if(!json) return undefined;

    let policy = undefined;
    if (json.policyType) {

      switch (json.policyType) {
        case POLICY_TYPE.OpeningHours: {
          policy = OpeningHoursPolicy.fromJSON(json);
          break;
        }
        case POLICY_TYPE.BookingHours: {
          policy = BookingHoursPolicy.fromJSON(json);
          break;
        }
        case POLICY_TYPE.MinSpend: {
          policy = MinSpendPolicy.fromJSON(json);
          break;
        }
        case POLICY_TYPE.TableBooking: {
          policy = TableBookingPolicy.fromJSON(json);
          break;
        }
        default: {
          policy = undefined;
          break;
        }
      }

      if (policy && policy.limits) {
        policy.limits = policy.limits.map(limit => {
          switch (policy.policyType) {
            case POLICY_TYPE.OpeningHours: {
              return OpeningHoursPolicyLimit.fromJSON(limit);
            }
            case POLICY_TYPE.BookingHours: {
              return BookingHoursPolicyLimit.fromJSON(limit);
            }
            case POLICY_TYPE.MinSpend: {
              return MinSpendPolicyLimit.fromJSON(limit);
            }
            case POLICY_TYPE.TableBooking: {
              return TableBookingPolicyLimit.fromJSON(limit);
            }
            default: {
              return undefined;
            }
          }
        });
      }
    }
    return policy;
  }
}

export class PolicyLimitConfiguration {
  constructor(policyTypeName, limitType) {
    this.policyTypeName = policyTypeName;
    this.limitType = limitType;
  }
}

export class POLICY_TYPE {
  static OpeningHours = 'OpeningHoursPolicy';
  static BookingHours = 'BookingHoursPolicy';
  static MinSpend = 'MinimumSpendPolicy';
  static TableBooking = 'TableBookingPolicy';

  static nameof(type) {
    switch (type) {
      case POLICY_TYPE.OpeningHours: {
        return 'Opening hours policy';
      }
      case POLICY_TYPE.BookingHours: {
        return 'Booking hours policy';
      }
      case POLICY_TYPE.MinSpend: {
        return 'Minimum spend policy';
      }
      case POLICY_TYPE.TableBooking: {
        return 'Table booking policy';
      }
      default: {
        return 'Unknown';
      }
    }
  }

  static getAll() {
    return [POLICY_TYPE.OpeningHours, POLICY_TYPE.BookingHours, POLICY_TYPE.MinSpend, POLICY_TYPE.TableBooking];
  }
}

export class POLICY_LIMIT_TYPE {
  static Hard = 1;
  static Soft = 2;
  static Warning = 3;

  static nameof(limitType) {
    switch (limitType) {
      case POLICY_LIMIT_TYPE.Hard: {
        return 'Hard';
      }
      case POLICY_LIMIT_TYPE.Soft: {
        return 'Soft';
      }
      case POLICY_LIMIT_TYPE.Warning: {
        return 'Warning';
      }
      default: {
        return 'Unknown';
      }
    }
  }
}

export class POLICY_LEVEL {
  static Venue = 0;
  static Setup = 10;
  static Section = 20;
  static Table = 30;
}
